import * as React from "react";
const SvgFiBrandsHaskell = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M0 20.465 5.647 12 0 3.535h4.235L9.882 12l-5.647 8.465z"
    />
    <path
      fill="#151A2D"
      d="M5.647 20.465 11.294 12 5.647 3.535h4.235l11.294 16.93h-4.235l-3.529-5.29-3.53 5.29zM19.294 15.527l-1.882-2.822H24v2.822zm-2.823-4.232L14.59 8.473H24v2.822z"
    />
  </svg>
);
export default SvgFiBrandsHaskell;
